<script>
	import Icon from './General/Icon.svelte';
	export let title = '';
	import { style } from '../lib/store';
	const urlParams = new URLSearchParams(window.location.search);
</script>

<div class="socials">
	{#if style === "BTS"}
		<a target="_blank" href="/?lagerhof-vehicle-pdf=true&route={urlParams.get('id')}"><Icon color="white" name="PRINT" size={19} /></a>
	{/if}
	<a target="_blank" href="mailto:?subject={title}&body=Check out this site: {window.location.href}"><Icon color="white" name="ENVELOPE" size={20} /></a>
	<a target="_blank" href="https://wa.me?text={window.location.href}"><Icon color="white" name="WHATSAPP" size={15} /></a>
	<a target="_blank" href="https://www.xing.com/spi/shares/new?url={window.location.href}"><Icon color="white" name="XING" size={17} /></a>
	<a target="_blank" href="https://www.facebook.com/sharer.php?u={window.location.href}"><Icon color="white" name="FACEBOOK" size={16} /></a>
</div>

<style>
	.socials {
		display: flex;
		align-items: center;
		gap: 15px;
	}
</style>
